module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.batchAddProduct
    }
  }, [_vm._v("批量新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.deleteProduce(false, -1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入渠道名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.chooseProduct.name))]), _vm._v(" "), _c('span', {
    staticClass: "pr-channel-text"
  }, [_vm._v("共有渠道"), _c('span', {
    staticClass: "pr-channel-num"
  }, [_vm._v(_vm._s(_vm.prChannelTotalNum))]), _vm._v("个，其中扣量渠道"), _c('span', {
    staticClass: "pr-channel-num"
  }, [_vm._v(_vm._s(_vm.prChannelNum))]), _vm._v("个。")])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channel",
      "fixed": "",
      "label": "渠道名称",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pr",
      "fixed": "",
      "label": "扣量比例",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "media_o",
      "fixed": "",
      "label": "扣量mieia_id",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "link_o",
      "fixed": "",
      "label": "扣量link_id",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "media",
      "fixed": "",
      "label": "原始mieia_id",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "link",
      "fixed": "",
      "label": "原始link_id",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '添加屏蔽规则' : '编辑屏蔽规则',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "1000px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.rule,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "扣量规则",
      "prop": "rule"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isAdd,
      "placeholder": "渠道名称"
    },
    model: {
      value: (_vm.rule.channel),
      callback: function($$v) {
        _vm.$set(_vm.rule, "channel", $$v)
      },
      expression: "rule.channel"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "扣量比例"
    },
    model: {
      value: (_vm.rule.pr),
      callback: function($$v) {
        _vm.$set(_vm.rule, "pr", $$v)
      },
      expression: "rule.pr"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "扣量mieia_id"
    },
    model: {
      value: (_vm.rule.media_o),
      callback: function($$v) {
        _vm.$set(_vm.rule, "media_o", $$v)
      },
      expression: "rule.media_o"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "扣量link_id"
    },
    model: {
      value: (_vm.rule.link_o),
      callback: function($$v) {
        _vm.$set(_vm.rule, "link_o", $$v)
      },
      expression: "rule.link_o"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原始mieia_id"
    },
    model: {
      value: (_vm.rule.media),
      callback: function($$v) {
        _vm.$set(_vm.rule, "media", $$v)
      },
      expression: "rule.media"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原始link_id"
    },
    model: {
      value: (_vm.rule.link),
      callback: function($$v) {
        _vm.$set(_vm.rule, "link", $$v)
      },
      expression: "rule.link"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false;
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量增加",
      "visible": _vm.batchDialog,
      "width": "850px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips))])], 1) : _vm._e(), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt2"
  }, _vm._l((['渠道名称', '扣量比例', '扣量media_id	', '扣量link_id', '原始media_id', '原始link_id']), function(it) {
    return _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(it))])
  }), 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        attrs: {
          "span": 4
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (this.batchTips == '导入预览') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32cb0ef4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rules/ALDlistDetail.vue
// module id = 1096
// module chunks = 2